import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useSettings } from '@/hooks/useSettings'

export function Testimonials() {
  const { testimonials: settings } = useSettings()
  const testimonials = settings?.testimonials?.length ? settings.testimonials : [
    {
      quote: 'Little Sky made me stop buying perfume blindly. The discovery set is brilliant.',
      author: 'Amara K.',
      fragrance: 'Velvet Ember',
    },
    {
      quote: 'I found my signature scent through the quiz. The sample credit toward a full bottle sealed it.',
      author: 'Daniel O.',
      fragrance: 'Dawn Citrus',
    },
    {
      quote: 'Dark, romantic, and lasts all evening. Noir Rose is a statement.',
      author: 'Tunde F.',
      fragrance: 'Noir Rose',
    },
  ]

  const [index, setIndex] = useState(0)
  const prev = () => setIndex((i) => (i === 0 ? testimonials.length - 1 : i - 1))
  const next = () => setIndex((i) => (i === testimonials.length - 1 ? 0 : i + 1))

  if (testimonials.length === 0) return null

  return (
    <section className="relative border-y border-line bg-paper py-24 lg:py-32">
      <div className="grid-lines text-carbon">
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>

      <div className="relative z-10 mx-auto max-w-3xl px-6 lg:px-10 text-center">
        <p className="mb-8 font-display text-display-md italic text-carbon">“</p>

        <AnimatePresence mode="wait">
          <motion.blockquote
            key={index}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            className="font-display text-2xl leading-relaxed text-carbon md:text-3xl"
          >
            {testimonials[index].quote}
          </motion.blockquote>
        </AnimatePresence>

        <p className="mt-6 text-sm text-carbon/60">
          {testimonials[index].author} · {testimonials[index].fragrance}
        </p>

        {testimonials.length > 1 && (
          <div className="mt-8 flex justify-center gap-4">
            <button onClick={prev} aria-label="Previous testimonial" className="text-carbon/40 hover:text-wd-orange">
              <ChevronLeft className="h-6 w-6" />
            </button>
            <button onClick={next} aria-label="Next testimonial" className="text-carbon/40 hover:text-wd-orange">
              <ChevronRight className="h-6 w-6" />
            </button>
          </div>
        )}
      </div>
    </section>
  )
}
